var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToolbarTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3L7.72361 2.55279C7.893 2.214 8.23926 2 8.61803 2H11.382C11.7607 2 12.107 2.214 12.2764 2.55279L12.5 3H15.5C16.3284 3 17 3.67157 17 4.5V5H3V4.5C3 3.67157 3.67157 3 4.5 3H7.5ZM4.5 6H15.5L15.0799 16.0833C15.0352 17.1545 14.1538 18 13.0816 18H6.9184C5.84622 18 4.96477 17.1545 4.92014 16.0833L4.5 6ZM7.77497 7C7.48938 7 7.26195 7.23908 7.27622 7.52431L7.72628 16.5256C7.73957 16.7913 7.95893 17 8.22503 17V17C8.51062 17 8.73805 16.7609 8.72378 16.4757L8.27372 7.47444C8.26043 7.20867 8.04107 7 7.77497 7V7ZM12.225 7C11.9589 7 11.7396 7.20867 11.7263 7.47444L11.2762 16.4757C11.262 16.7609 11.4894 17 11.775 17V17C12.0411 17 12.2604 16.7913 12.2737 16.5256L12.7238 7.52431C12.738 7.23908 12.5106 7 12.225 7V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolbarTrash);
export default __webpack_public_path__ + "static/media/icon-toolbar-trash.b8ff56360aea6357ee69337893d82867.svg";
export { ForwardRef as ReactComponent };